/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Reason_In_From_PxkInputs */

const vi_scl_new_reason_in_from_pxk = /** @type {(inputs: Scl_New_Reason_In_From_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ phiếu xuất lô phân loại`)
};

/**

* @param {Scl_New_Reason_In_From_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_reason_in_from_pxk = /** @type {((inputs?: Scl_New_Reason_In_From_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Reason_In_From_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_reason_in_from_pxk(inputs)
});